import { useEffect, useState } from 'react';
import { getLmsLocations } from '../api';
import { lmsLocation } from '../interfaces';

const initialState = {
  isLoading: false,
  lmsLocationList: [],
  jobNo: '',
};

export default function useLmsLocation(isAdmin: boolean) {
  const [lmsLocationList, setLmsLocationList] = useState<lmsLocation[]>([]);
  const [isLoadingLocations, setIsLoadingLocations] = useState<boolean>(false);

  const fetchLmsLocations = async (payload: any) => {
    const { lmsLocations } = await getLmsLocations(
      payload,
      isAdmin,
      setIsLoadingLocations,
    );
    setLmsLocationList(lmsLocations);
  };

  useEffect(() => {
    setIsLoadingLocations(initialState.isLoading);
    setLmsLocationList(initialState.lmsLocationList);
    fetchLmsLocations(initialState);
  }, [isAdmin]);

  return {
    lmsLocationList,
  };
}
